import './checkbox.svg';
import './form-option.scss';

import { components } from 'gridstrap/lib/gs-components';
import { GSFormOption } from './form-option';

components.register({
	selector: '.gs-FormOption',
	controller: GSFormOption
});

